import fp from 'lodash/fp';

import { ActionLookupReducer, lookupTableReducer } from 'Modules/core/redux';

import { messagingActions } from './actions';
import { MessagingQueueTypes, MessagingState, UpdateModalProps } from './types';


const defaultState = [];

const actionLookup: ActionLookupReducer<MessagingState> = {
    [`${messagingActions.enqueue}`]: (state, message: MessagingQueueTypes) => [...state, message],

    [`${messagingActions.updateModalProps}`]: (state, { id, props, ...modalProps }: UpdateModalProps) => state.map(
        m => m.id === id
            ? { ...m, ...modalProps, props: fp.merge(m.props, props) }
            : m,
    ),

    [`${messagingActions.hideMessage}`]: (state, id: number) => state.filter(m => m.id !== id),

    [`${messagingActions.closeAll}`]: state => state.filter(m => !m.isModal),
};

export const reducer = lookupTableReducer(defaultState, actionLookup);
